// Auto-generated. Do not edit manually.
export const currentVersion = {
  version: "1.11.1",
  releaseDate: "October 21, 2026",
};
